export default __webpack_public_path__ + "static/media/RACK.8a284087.png";